export interface Session {
  uid: string | null;
  email: string | null;
  token: string | null;
  refreshToken: string | null;
  userId: string | null;
  accountId: string | null;
  ownerId: string | null;
  planId: string | null;
  roles: string[];
}

export const ANONYMOUS_SESSION: Session = {
  uid: null,
  email: null,
  token: null,
  refreshToken: null,
  userId: null,
  accountId: null,
  ownerId: null,
  planId: null,
  roles: [],
};
